export default () => ({
  trigger: {
    name: 'review_panel.show_review_translation_toggle',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'review translation toggle',
      },
    },
    nonInt: true,
  },
});
